import { useEffect } from 'react';
import { dispatch } from 'nike-re-framejs';
import { loadMatchtrackerTemplates } from '../handlers';

export function useLoadMatchtrackerTemplates(reload = true) {
    useEffect(() => {
        if (reload) {
            dispatch(loadMatchtrackerTemplates);
        }
    }, [reload]);
}
